<template>
  <div class="container-fluid">
    <b-row class="no-gutters justify-content-center container-fluid my-5">
      <b-col cols="12" md="8" sm="10">
        <h5>Groupe</h5>
        <p>
          Les groupes permettent de rassembler les étudiants pour faciliter leur
          évaluation.
        </p>
        <b-row>
          <b-col cols="12" sm="8" lg="7" xl="5" class="border-bottom mb-4">
            <b-table
              :items="teacherGroups.data.data"
              :fields="fields"
              :borderless="true"
            >
              <template v-slot:cell(id)="row">
                <b-btn
                  @click="
                    deletGroup({
                      group_id: row.item.id,
                      status: 0
                    })
                  "
                  size="sm"
                  class="ml-1"
                  variant="none"
                  pill
                >
                  <img
                    src="@/assets/img/u2327.png"
                    class="d-inline-block align-center temp-icon"
                  />
                </b-btn>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <!-- User Interface controls -->
        <b-row>
          <b-col cols="4">
            <b-pagination
              pills
              v-model="table.currentPage"
              :total-rows="table.totalRows"
              :per-page="table.perPage"
              class="my-0"
              @change="pageChange"
            ></b-pagination>
          </b-col>
        </b-row>
        <b-row class="my-5">
          <b-col cols="12" sm="8" lg="7" xl="5">
            <span> Ajouter un groupe </span>
            <b-form inline class="mt-2">
              <b-input
                class="mb-2 mr-sm-2 mb-sm-0"
                v-model="groupName"
              ></b-input>

              <b-button
                variant="primary"
                pill
                @click="createGroup()"
                :disabled="!groupName"
                ><BIconPlus></BIconPlus
              ></b-button>
            </b-form>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/**
 * @file       Teachers groups component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import { mapState } from "vuex";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  /**
   * Before route change.
   * 
   * @param  {string}   to     Destination
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    store.commit("groups/setTeacherGroupsFilters", {
      reset: true,
      fields: {
        teacher: parseInt(to.params.id),
        status: 1
      }
    });
    store.dispatch("groups/getTeacherGroups").then(() => next());
  },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      groupName: null,
      fields: [
        {
          key: "name",
          label: "Nom de groupe"
        },
        {
          key: "id",
          label: "",
          class: "text-center"
        }
      ]
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      teacherGroups: state => state.groups.teacherGroups,
      profile: state => state.auth.profile.data.data[0]
    }),

    /**
     * Pager table.
     *
     * @return     {Object}
     */
    table() {
      return {
        totalRows: this.teacherGroups.data.total,
        currentPage: this.teacherGroups.data.current_page,
        perPage: this.teacherGroups.data.per_page
      };
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Change teacher groups page.
     *
     * @param      {int}  page     The page number
     */
    pageChange(page) {
      store.commit("groups/setTeacherGroupsFilters", {
        fields: { page }
      });
      store.dispatch("groups/getTeacherGroups");
    },

    /**
     * Create teacher group.
     */
    createGroup() {
      const payload = {
        name: this.groupName,
        status: 1,
        teacher: this.profile.id
      };
      store
        .dispatch("groups/postTeacherGroup", payload)
        .then(() => {
          this.$root.$bvToast.toast(
            `Le group "${this.groupName}" a été créé avec succès`,
            {
              title: "Succès"
            }
          );
          store.commit("groups/setTeacherGroupsFilters", {
            reset: true,
            fields: {
              teacher: this.profile.id,
              status: 1
            }
          });
          store.dispatch("groups/getTeacherGroups");
          this.groupName = null;
        })
        .catch(() => {
          this.$root.$bvToast.toast("La création du groupe a échoué", {
            title: "Erreur",
            variant: "danger"
          });
        });
    },
    /**
     * Delete teachers group.
     *
     * @param   {Object}    payload         The payload
     */
    deletGroup(payload) {
      store
        .dispatch("groups/deleteTeacherGroup", payload)
        .then(() => {
          this.$root.$bvToast.toast(`Le groupe a été supprimé`, {
            title: "Succès"
          });
          store.commit("groups/setTeacherGroupsFilters", {
            reset: true,
            fields: {
              teacher: this.profile.id,
              status: 1
            }
          });
          store.dispatch("groups/getTeacherGroups");
        })
        .catch(() => {
          this.$root.$bvToast.toast("Ce groupe ne peut être supprimé", {
            title: "Erreur",
            variant: "danger"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
